import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject, forkJoin } from 'rxjs';
import { UserInfoService } from './user-info.service';
import { ApiRequestService } from './api-request.service';
import { LookupDataService } from './lookupdata.service';
import { TranslateService } from './translate.service';
import { CriteriaIO } from '../../shared/models/CriteriaIO.model';
import { SearchCriteriaDO } from '../../shared/models/SearchCriteria.model';
import { CommonUtilty } from '../utilities/commonUtility'
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { NewBusinessAppSettings } from 'app/ViewModules/Newbusiness/newbusiness-configs';

@Injectable()
export class WorkqueueService {

    public myTasklist = []

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        private userInfoService: UserInfoService,
        private lookupdataService: LookupDataService,
        private commonUtilty: CommonUtilty,
        public appMetadataHandler: AppMetadataHandler,
        private _newBusinessAppSettings: NewBusinessAppSettings
    ) { }

    getTaskList(userId): Observable<any> {
        let me = this;
        //    let userId = null
        let taskSearchData: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        //  userId = this.userInfoService.getUserId();
        console.log(userId)
            if (userId !== 'no-user') {
                let pathVariables = [];
                pathVariables.push(userId);
                let searchURL = 'fetchTasksAssignedToUser';
                this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
                // let searchURL = 'fetchTasksAssignedToUser/' + userId;
                // this.apiRequest.getCallWithAPIMapper(searchURL)
                    .subscribe(jsonResp => {
                        console.log("task list response", JSON.stringify(jsonResp));
                        this.myTasklist = jsonResp;
                        this.myTasklist = this.addURLs();
                        this.myTasklist = this.addTaskDescription(this.myTasklist);
                        let returnObj = this.commonUtilty.sortObject('id', this.myTasklist, 'desc');
                        taskSearchData.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    });
            } else {
                taskSearchData.next([]);
            }
        return taskSearchData;
    }

    applyCountToParentNode(nodes, workQueueAPIResponse) {
        if (nodes && Array.isArray(nodes)) {
            nodes.forEach(WorkQueTreeDO => {
                let totalCount = 0
                if (WorkQueTreeDO.children && Array.isArray(WorkQueTreeDO.children)) {
                    WorkQueTreeDO.children.forEach(workQueChild => {
                        let childCount = workQueueAPIResponse.filter(resp => workQueChild.key == resp.workQueue)
                        workQueChild.count = childCount.length
                        workQueChild['title'] = `${workQueChild['title']} (${workQueChild.count})`
                        totalCount += workQueChild.count
                        /*if (workQueChild.count === 0) {
                            workQueChild.disabled = true
                        }*/
                    })
                }
                let parentCount
                if (totalCount != 0)
                    WorkQueTreeDO['count'] = totalCount
                else {
                    parentCount = workQueueAPIResponse.filter(resp => WorkQueTreeDO.key == resp.workQueue)
                    WorkQueTreeDO.count = parentCount.length
                    totalCount = WorkQueTreeDO.count
                }
                WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`
                /*if (totalCount == 0) {
                    WorkQueTreeDO.expanded = false
                    WorkQueTreeDO.isLeaf = true
                    WorkQueTreeDO.icon = 'minus-circle'
                    WorkQueTreeDO.disabled = true
                }
                else {*/
                    if (!this.commonUtilty.isArrayIterable(WorkQueTreeDO.children)) {
                        WorkQueTreeDO.isLeaf = true
                        WorkQueTreeDO.icon = 'folder'
                    }
                    else {
                        //If you want to do something with caret sign nodes
                    }
                //}
            })
        }

        return nodes
    }



    addURLs() {
        for (var k = 0; k < this.myTasklist.length; k++) {
            if (this.myTasklist[k].serviceTask == 'claimIntimation') {
                this.myTasklist[k].routeURL = "/app/claims/transaction/details";
            }
            if (this.myTasklist[k].serviceTask == 'serviceDataEntryTask') {
                this.myTasklist[k].routeURL = "/home/newServiceRequest/" + this.myTasklist[k].entityGuid;
            }
        }

        return this.myTasklist;
    }

    addTaskDescription(tasklist = []) {

        let lookupArr = ["taskStatusCd", "productFamilyCd", "taskCd"];
        let taskDesc = [];
        let productFamilyLookup = [];
        let statusLookup = [];
        let observables = new Array();
        for (let item of lookupArr) {
            observables.push(this.lookupdataService.getLookup(item));
        }

        forkJoin(observables).subscribe(
            res => {
                let response: any[] = res;
                for (let lookupList of response) {
                    if (lookupList[0].lookupCd == "productFamilyCd") {
                        productFamilyLookup = lookupList
                    }
                    if (lookupList[0].lookupCd == "taskStatusCd") {
                        statusLookup = lookupList
                    }
                    if (lookupList[0].lookupCd == "taskCd") {
                        taskDesc = lookupList
                    }
                }
                for (var j = 0; j < tasklist.length; j++) {
                    for (var i = 0; i < taskDesc.length; i++) {
                        if (tasklist[j].serviceTask == taskDesc[i].lookupKey) {
                            tasklist[j].taskDescription = taskDesc[i].lookupValue
                        }
                    }
                    for (var i = 0; i < productFamilyLookup.length; i++) {
                        if (tasklist[j].productFamilyCd == productFamilyLookup[i].lookupKey) {
                            tasklist[j].familyDesc = productFamilyLookup[i].lookupValue
                        }
                    }
                    for (var i = 0; i < statusLookup.length; i++) {
                        if (tasklist[j].status == statusLookup[i].lookupKey) {
                            tasklist[j].statusDesc = statusLookup[i].lookupValue
                        }
                    }
                }


                console.log(res);

            },
            error => console.log('Error: ', error)
        );

        return tasklist;



    }

    getAudit(guid, serviceTask): Observable<any> {
        let me = this;
        let searchURL= 'fetchAuditLog';
        // let searchURL= '/master/auditlog/entityGuid/' + guid;
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return workQueues;
    }

    getOlLog(guid: any) {
        let me = this;
        let url
        let auditLogSubject = new Subject<any>();
        //url = 'oldRequestLog/'
         url = 'fetchAuditOldVersion'
        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                auditLogSubject.next(returnObj);
            });
         return auditLogSubject;
    }

    setSLA(workQueueAPIResponse) {
        var currentDate = new Date().getTime();

        for (var i = 0; i < workQueueAPIResponse.length; i++) {
            var slaExpired = false;
            var levelenddate = workQueueAPIResponse[i].levelEndTime;
            if (currentDate < levelenddate) {
                slaExpired = true;
                var millisec = workQueueAPIResponse[i].levelEndTime - currentDate;
                workQueueAPIResponse[i].SLA = this.getDifference(millisec);
                // workQueueAPIResponse[i].level=workQueueAPIResponse[i].levelType
            }

            if (slaExpired == false) {
                workQueueAPIResponse[i].level = "Expired"
                workQueueAPIResponse[i].SLA = "-"
            }
        }
        return workQueueAPIResponse
    }


    getDifference(millisec) {
        var seconds = Math.round(millisec / 1000);

        var minutes = Math.round(millisec / (1000 * 60));
        // var min=(millisec / (1000 * 60)).toPrecision(4);

        var hours = (millisec / (1000 * 60 * 60));

        var days = Math.round(millisec / (1000 * 60 * 60 * 24));


        if (seconds < 60) {
            return seconds + " Secs";
        } else if (minutes < 60.) {
            return minutes + " Mins";
        } else if (hours < 24) {
            var hr = Math.floor(hours);
            var mins = Math.round((hours - Math.floor(hours)) * 60);
            return hr + " Hrs " + mins + " mins ";
        } else {
            return days + " Days";
        }
    }



    getUnassignedTaskList(): Observable<any> {
        let me = this;
        let userId = null
        let taskSearchData: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let searchURL = 'fetchUnassignedTasksForUser';
            let pathVariables = [];
            pathVariables.push(userId)
            this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    returnObj = this.addTaskDescription(returnObj);
                    taskSearchData.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            taskSearchData.next([]);
        }
        return taskSearchData;
    }

    getSubordinateTasks() {
        let pathVariables = [];
        let me = this;
        let userId = null
        let taskSearchData: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        // pathVariables.push(userId || 'null');
        console.log(userId)
        if (userId !== 0) {
            let pathVariables = [];
            pathVariables.push(userId);
            let searchURL = 'fetchQManagerTasks';
            this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            // let searchURL = 'fetchQManagerTasks/' + userId;
            // this.apiRequest.getCallWithAPIMapper(searchURL)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    this.myTasklist = jsonResp;
                    ;
                    this.myTasklist = this.addURLs();
                    this.myTasklist = this.addTaskDescription(this.myTasklist);
                    ;
                    let returnObj = this.myTasklist;
                    taskSearchData.next(returnObj);
                    // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            taskSearchData.next([]);
        }
        return taskSearchData;

    }

    getTeammateTasks() {
        let me = this;
        let userId = null
        let taskSearchData: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let pathVariables = [];
            pathVariables.push(userId);
            let searchURL = 'fetchUserManagerTasks';
            this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            // let searchURL = 'fetchUserManagerTasks/' + userId;
            // this.apiRequest.getCallWithAPIMapper(searchURL)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    this.myTasklist = jsonResp;
                    ;
                    this.myTasklist = this.addURLs();
                    this.myTasklist = this.addTaskDescription(this.myTasklist);
                    ;
                    let returnObj = this.myTasklist;
                    taskSearchData.next(returnObj);  // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            taskSearchData.next([]);
        }
        return taskSearchData;

    }

    searchTasks(searchCriteria, searchCriteriaValue, searchCriteriaValue1, viewName): Observable<any> {
        let me = this;
        let userId = null
        let taskSearchData: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {

            var criteriaObj = new CriteriaIO();
            let searchCriteriaList: SearchCriteriaDO[] = [];

            var searchCriteriaDO1 = new SearchCriteriaDO();
            searchCriteriaDO1.setParamName("userId");
            searchCriteriaDO1.setParamValue(userId);
            searchCriteriaList.push(searchCriteriaDO1);

            var searchCriteriaDO2 = new SearchCriteriaDO();
            searchCriteriaDO2.setParamName("viewName");
            searchCriteriaDO2.setParamValue(viewName);
            searchCriteriaList.push(searchCriteriaDO2);

            var searchCriteriaDO3 = new SearchCriteriaDO();
            searchCriteriaDO3.setParamName("searchkey");
            searchCriteriaDO3.setParamValue(searchCriteria);
            searchCriteriaList.push(searchCriteriaDO3);

            var searchCriteriaDO4 = new SearchCriteriaDO();
            searchCriteriaDO4.setParamName("searchValue");
            searchCriteriaDO4.setParamValue(searchCriteriaValue);
            searchCriteriaList.push(searchCriteriaDO4);

            var searchCriteriaDO5 = new SearchCriteriaDO();
            searchCriteriaDO5.setParamName("searchValueTwo");
            searchCriteriaDO5.setParamValue(searchCriteriaValue1);
            searchCriteriaList.push(searchCriteriaDO5);

            criteriaObj.setSearchCriteriaList(searchCriteriaList);

            let searchURL = 'inbox/searchInbox';
            this.apiRequest.post(searchURL, criteriaObj)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    this.myTasklist = jsonResp;
                    this.myTasklist = this.addURLs();
                    this.myTasklist = this.addTaskDescription(this.myTasklist);
                    let returnObj = this.myTasklist;
                    taskSearchData.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            taskSearchData.next([]);
        }
        return taskSearchData;
    }


    getProducts(): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        let planType = "BASEPLAN";
        console.log(planType);
        let productSearchData: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'fetchProductByPlanType';
        let pathVariables = [];
        pathVariables.push(planType);
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                productSearchData.next(jsonResp); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return productSearchData;
    }

    getTeamUsers(): Observable<any> {
        let me = this;
        let userId = null
        let teamUsers: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let updateURL = 'fetchTeamUsers';
            let pathVariables = [];
            pathVariables.push(userId);
            this.apiRequest.getCallWithAPIMapper(updateURL, null, null, pathVariables)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    teamUsers.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                }, errResp => {
                    teamUsers.next(errResp);
                });
        } else {
            teamUsers.next([]);
        }
        return teamUsers;
    }


    assignTaskToUser(taskId): Observable<any> {
        let me = this;
        let userId = null
        let assignmentStatus: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let pathVariables = [];
            pathVariables.push(taskId);
            pathVariables.push(userId);
            let updateURL = 'inboxAssignTaskToUser';
            this.apiRequest.getCallWithAPIMapper(updateURL, null, null, pathVariables)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    assignmentStatus.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                }, errResp => {
                    assignmentStatus.next(errResp);
                });
        } else {
            assignmentStatus.next([]);
        }
        return assignmentStatus;
    }


    reassignTaskToUser(taskId, userId, tasklist?): Observable<any> {

        let assignmentStatus: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt

        if (userId !== 'no-user') {
            if (Array.isArray(taskId))
                taskId = taskId.toString();

            let pathVariables = [];
            pathVariables.push(taskId);
            pathVariables.push(userId);

            let updateURL = 'assignTaskToUser';
            this.apiRequest.getCallWithAPIMapper(updateURL, null, null, pathVariables)
            // let updateURL = 'assignTaskToUser/' + taskId + "/" + userId;
            // this.apiRequest.getCallWithAPIMapper(updateURL)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    if (tasklist)
                        returnObj["taskList"] = tasklist
                    assignmentStatus.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            assignmentStatus.next([]);
        }
        return assignmentStatus;
    }

    getUsers(queueCd): Observable<any> {
        let users: Subject<any> = new Subject<any>();
        let pathVariables = [];
        pathVariables.push(queueCd);
        let searchURL = 'fetchQueueSubscriptions';
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                users.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return users
    }


    getWorkQueues(): Observable<any> {
        let me = this;
        let userId = null
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let pathVariables = [];
            pathVariables.push(userId);
            let searchURL = 'fetchUserQueueSubscriptions';
            this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            // let searchURL = 'fetchUserQueueSubscriptions/' + userId;
            // this.apiRequest.getCallWithAPIMapper(searchURL)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            workQueues.next([]);
        }
        return workQueues;

    }

    getAllWorkQueues(): Observable<any> {
        let me = this;
        let userId = null
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let searchURL = 'fetchAllWorkqueues';
            this.apiRequest.getCallWithAPIMapper(searchURL)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            workQueues.next([]);
        }
        return workQueues;

    }


    getWorkQueuesByManagerId(): Observable<any> {
        let me = this;
        let userId = null
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let pathVariables = [];
            pathVariables.push(userId);
            let searchURL = 'fetchQueueByManagerId';
            this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
        } else {
            workQueues.next([]);
        }
        return workQueues;

    }
    getReportedUsers(): Observable<any> {
        let me = this;
        let userId = null
        let teamUsers: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        userId = this.userInfoService.getUserId();
        console.log(userId)
        if (userId !== 'no-user') {
            let pathVariables = [];
            pathVariables.push(userId);
            let updateURL = 'fetchReportees';
            this.apiRequest.getCallWithAPIMapper(updateURL, null, null, pathVariables)
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    let returnObj = jsonResp;
                    teamUsers.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                }, errResp => {
                    teamUsers.next(errResp);
                });
        } else {
            teamUsers.next([]);
        }
        return teamUsers; {

        }
    }

    _workFlowAuditURLMap = {
        claimIntimation: "claim/workflw/fetchByIntimationGuid",
        claimRegistration: "claim/workflw/fetchByClaimGuid",
        claimInvestigation: "claim/workflw/fetchByClaimGuid",
        claimAdjudication: "claim/workflw/fetchByClaimGuid",
        claimPayout: "claim/workflw/fetchByClaimGuid",
        claimUWReferral: "claim/workflw/fetchByClaimGuid",
        claimReinsReferral: "claim/workflw/fetchByClaimGuid",
        claimHOReferralWaiver: "claim/workflw/fetchByClaimGuid",
        claimHOReferralOpinion: "claim/workflw/fetchByClaimGuid",
        claimsCommitteeReferral: "claim/workflw/fetchByClaimGuid",
        preAuthRegistration: "hlthclaim/workflw/fetchByPreauthGuid",
        preAuthAdjudication: "hlthclaim/workflw/fetchByPreauthGuid",
        healthClaimRegistration: "hlthclaim/workflw/fetchByHlthClaimGuid",
        healthClaimAdjudication: "hlthclaim/workflw/fetchByHlthClaimGuid"
        // claim/workflw/fetchByClaimGuid
        // hlthclaim/workflw/fetchByHlthClaimGuid
    }
    getWorkflowAudit(guid, serviceTask): Observable<any> {
        let me = this;
        let searchURL
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt

        let pathVariables = [];
        pathVariables.push(guid || null);

        if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
            searchURL = this._workFlowAuditURLMap[serviceTask];
        else
            searchURL = 'fetchTaskByEntityguid';
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)

        // if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
        //     searchURL = this._workFlowAuditURLMap[serviceTask] + guid;
        // else
        //     searchURL = 'fetchTaskByEntityguid' + guid;
        // this.apiRequest.getCallWithAPIMapper(searchURL)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return workQueues;
    }

    getWorkflowAuditForClaim(guid, serviceTask): Observable<any> {
        let me = this;
        let searchURL
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        
        let pathVariables = [];
        pathVariables.push(guid || null);

        if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
            searchURL = this._workFlowAuditURLMap[serviceTask];
        else
            searchURL = 'fetchTaskByEntityguid';
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)

        // if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
        //     searchURL = this._workFlowAuditURLMap[serviceTask] + guid;
        // else
        //     searchURL = 'fetchTaskByEntityguid' + guid;
        // this.apiRequest.getCallWithAPIMapper(searchURL)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return workQueues;
    }
    getHealthWorkflowAudit(guid, serviceTask): Observable<any> {
        let me = this;
        let searchURL
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        
        let pathVariables = [];
        pathVariables.push(guid || null);

        if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
            searchURL = this._workFlowAuditURLMap[serviceTask];
        else
            searchURL = 'fetchTaskByEntityguid';
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)

        // if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
        //     searchURL = this._workFlowAuditURLMap[serviceTask] + guid;
        // 
        //     searchURL = 'fetchTaskByEntityguid' + guid;
        // this.apiRequest.getCallWithAPIMapper(searchURL)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return workQueues;
    }

    getHealthWorkflowAuditForClaim(guid, serviceTask): Observable<any> {
        let me = this;
        let searchURL
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        if (this.appMetadataHandler.featureFlags.enableSeparateAPICallsForWorflowAuditForIntimationAndClaims)
            searchURL = this._workFlowAuditURLMap[serviceTask] + guid;
        else
            searchURL = 'fetchByHlthClaimGuid';
        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return workQueues;
    }


    getcorrespondence(guid): Observable<any> {
        let me = this;
        let workQueues: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'fetchNoteByGuid';
        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                console.log(jsonResp)
                let returnObj = jsonResp;
                workQueues.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return workQueues;
    }

    createTask(body: any): Observable<any> {
        let me = this;

        let createTaskSubject = new Subject<any>();
        this.apiRequest.post('task/createTask', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                createTaskSubject.next(returnObj);
            });

        return createTaskSubject;
    }

    freezeTask(taskId: any): Observable<any> {
        let me = this;
        let freezeTaskSubject = new Subject<any>();
        let url = 'freezeTask';
        let pathVariables = [];
        pathVariables.push(taskId);
        this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                freezeTaskSubject.next(returnObj);
            });

        return freezeTaskSubject;
    }

    unfreezeTask(taskId: any): Observable<any> {
        let me = this;
        let unfreezeTaskSubject = new Subject<any>();
        let url = 'resumeTask';
        let pathVariables = [];
        pathVariables.push(taskId);
        this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                unfreezeTaskSubject.next(returnObj);
            });

        return unfreezeTaskSubject;
    }

    markAsStarred(taskId: any): Observable<any> {
        let me = this;
        let markAsStarredSubject = new Subject<any>();
        let url = 'starMarkTask';
        let pathVariables = [];
        pathVariables.push(taskId);
        this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                markAsStarredSubject.next(returnObj);
            });

        return markAsStarredSubject;
    }

    fetchProducts(productFamilyCd): Observable<any> {
        let me = this;
        // api/product/fetchByPlantypeAndProductFamilyAndEntryDate/{planTypeCd}/{productFamilyCd}/{submissionMode}/{proposalEntryDate}
        let body = {
            planTypeCd: 'BASEPLAN',
            productFamilyCd: productFamilyCd,
            submissionMode: this._newBusinessAppSettings.APPCONSTANTS.submissionMode,
            proposalEntryDate: this._newBusinessAppSettings.APPCONSTANTS.proposalEntryDate,
            productStatus: this._newBusinessAppSettings.APPCONSTANTS.productStatus
        }
        let data = body.planTypeCd + "/" + body.productFamilyCd + "/" + body.submissionMode + "/" + body.proposalEntryDate;
        
        let pathVariables = []
        pathVariables.push(body.productStatus)
        pathVariables.push(body.planTypeCd)
        // pathVariables.push(body.productFamilyCd)
        // pathVariables.push(body.submissionMode)
        // pathVariables.push(body.proposalEntryDate)
        let FetchRiderSubject = new Subject<any>();
        this.apiRequest.getCallWithAPIMapper('fetchByProductStatusAndPlanType',null,null,pathVariables)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                FetchRiderSubject.next(returnObj);
            });

        return FetchRiderSubject;
    }

    fetchRiders(product) {
        let riderListSubject: Subject<any> = new Subject<any>();
        let pathVariables = [];
        pathVariables.push(product);
        let riderListServiceURL = 'fetchRiders';
        // let riderListServiceURL = 'fetchRiders' + product;
        let DataList: any[] = [];
        this.apiRequest.getCallWithAPIMapper(riderListServiceURL, null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper(riderListServiceURL)
            .subscribe(jsonResp => {
                if (this.commonUtilty.isArrayIterable(jsonResp)) {
                    jsonResp.forEach(element => {
                        DataList.push(element);
                    });
                }
                riderListSubject.next(DataList);
                riderListSubject.complete();

            })

        return riderListSubject;

    }

    fetchUIMetadata(productCd) {
        let me = this;
        let metadataSubject = new Subject<any>();
        //let url = `api/productMetadata/fetchBasePlanMetadata/${productCd}`;
        // let url = `apiProductMetadata/${productCd}/entity/${this.appMetadataHandler.entityCd}`;
        let url = 'apiProductMetadata'
        let pathVariables = []
        pathVariables.push(productCd)
        pathVariables.push(this.appMetadataHandler.entityCd)
        this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp => {
            let returnObj = this.commonUtilty.deepCopy(resp);
            metadataSubject.next(returnObj);
        })
        return metadataSubject;
    }
    
}

